module.exports = __webpack_public_path__ + "static/img/brand-1.8780b54.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/brand-1.svg
// module id = HwXO
// module chunks = 0